var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',[_c('v-slide-x-transition',{attrs:{"hide-on-leave":""}},[_c('router-view')],1),_c('AdminSidebar')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }